/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {OverviewPeriodRange, OverviewReview} from '../../../../util/interfaces';

import {getOverviewReviews} from '../../../../util/requestSender';

import {useOverviewSection} from '../useOverviewSection';

import Reviews from './reviews';

interface Props {
    accountIds: Array<string>;
    period: OverviewPeriodRange;
}

export default function ReviewsController({accountIds, period}: Props) {
    const section = useOverviewSection<OverviewReview>({request: getOverviewReviews, accountIds, period});

    return <Reviews {...section} />;
}
